<template>
  <div>
    <b-jumbotron
      header="Sharing is caring."
      lead="Real time content sharing made easy."
    >
    <b-button variant="light" href="/demo">Example</b-button>
    </b-jumbotron>

<b-form inline @submit="CreateTag">

 <label class="sr-only" for="inline-form-input-tag">Pick a tag name to start</label>
    <b-input-group prepend="etell.me/" class="mb-2 mr-sm-2 mb-sm-0">
      <b-form-input id="inline-form-input-tag" placeholder="input a tag name" v-model="form.tagName" required></b-form-input>
    </b-input-group>
     <b-button variant="primary" type="submit">Create</b-button>
  </b-form>


  </div>
</template>

<script>

import slugify from 'slugify';

export default {
  name: 'main-app',
  props: [],
  components: {},
  data: () => {
    return {
      pageName: 'main',
      form: {tagName: ''},
    };
  },

  created: function() {
    this.$store.commit('setCurrentPageName', this.pageName);
    console.log(`page name: ${this.pageName}`)
  },

  computed: {},

  methods: {
    CreateTag() {
      let slugifiedTagName = slugify(this.form.tagName);
      console.log(slugifiedTagName);
      this.$router.push({path: `/${slugifiedTagName}`});
    }
  }
};
</script>

<style scoped>
.jumbotron {
  background-image: url("https://firebasestorage.googleapis.com/v0/b/etell-me.appspot.com/o/content-sharing.png?alt=media&token=5dbbd7f3-bec3-4153-9ca7-1bf9ea6fea1d");
  background-size: cover;
}

.jumbotron .display-3 {
    font-size: 4.5rem;
    font-weight: 400;
    line-height: 1.2;
    /* color: #131212; */
    text-shadow: rgb(236, 232, 232) 0px 0px 10px;
}

.jumbotron .lead {
    font-size: 1.5rem;
    font-weight: 500;
    text-shadow: rgb(236, 232, 232) 0px 0px 10px;
}
</style>